import React from "react";
import {PlatformIconData} from "../../data/Icons/PlatformData";

export const PlatformIconProvider = {
    getIconData,
    getIconItem,
    getIconItemByName
};

function getIconData() {
    return PlatformIconData.map((iconData, index) => {
        const {id, value, name} = iconData
        return (
            {
                id: id,
                value: name,
                label: <div><span className={value}/><span>    </span><label>{name}</label></div>
            }
        )
    });
}

function getIconItemByName(name) {
    const index = PlatformIconData.findIndex(n => n.name === name);

    if (index === -1) {
        return;
    }

    return (
        {
            id: PlatformIconData[index].id,
            value: PlatformIconData[index].name,
            label: <div><span
                className={PlatformIconData[index].value}/><span>    </span><label>{PlatformIconData[index].name}</label>
            </div>
        }
    )
}

function getIconItem(id) {
    const index = PlatformIconData.findIndex(n => n.name === id);

    if (index === -1) {
        return;
    }

    return (
        {
            id: PlatformIconData[index].id,
            value: PlatformIconData[index].name,
            label: <div><span
                className={PlatformIconData[index].value}/><span>    </span><label>{PlatformIconData[index].name}</label>
            </div>
        }
    )
}